module.exports = __webpack_public_path__ + "static/media/TurnUpVolume.f8a94bdb.png";